export default __webpack_public_path__ + "static/media/partnershipPackage2022.9362526b.pdf";